import ProfileListPage from "./profile-list-page.jsx";

export default ProfileListPage;